// extracted by mini-css-extract-plugin
export default {"wrapper":"XhYlBaJbFrMzn_Jyy3RU","rule":"rf25FOf6uMoXSXXDM2VF","title":"yK3Zp9CsKxRGZP3wyjl_","text":"a7LHT8TtO3nUrKGOfV9S","formula":"A4WuF8uT6DaMHxyV6N7I"};